import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux"
import { actionCreators } from "../../state"
import { euroQtyFormat, euroFormat, quantityFormat } from "../../utils"
import Popup from "../Popup"
import Slider from '@mui/material/Slider';
import GenericPopup from "./GenericPopup"
import PopupRowData from "./utils/PopupRowData"
import PopupLabelAndValue from "./utils/PopupLabelAndValue"
import PopupDivider from "./utils/PopupDivider"


export default function RemoveLPPopup(props: { closeFunction: Function, uuidLP: string }): JSX.Element {

    //let uuid = props.uuidLP
    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)

    const [detailsLPRequest, setDetailsLPRequest] = useState()
    const [issuedTokens, setIssuedTokens] = useState<any>()
    const [balance, setBalance] = useState<any>()

    const [uuid, setUuid] = useState<string>("")

    const [lpName, setLpName] = useState<string>("LP_")
    const [tokenA, setTokenA] = useState<string>("")
    const [tokenB, setTokenB] = useState<string>('XEUR')
    const [assetName, setAssetName] = useState<string>("")
    const [tokenAName, setTokenAName] = useState<string>("")
    const [tokenBName, setTokenBName] = useState<string>("")
    const [maxTokenA, setMaxTokenA] = useState<number>(0)
    const [maxIssuerTokenA, setMaxIssuerTokenA] = useState<number>(0)
    const [maxTokenB, setMaxTokenB] = useState<number>(0)

    const [lpAmountA, setLpAmountA] = useState<number>(0)
    const [lpAmountB, setLpAmountB] = useState<number>(0)
    const [shares, setShares] = useState<any[]>([])
    const [lpShares, setLpShares] = useState<number>(0)
    const [sharesOwned, setSharesOwned] = useState<number>(0)
    const [sharesOwnedPercTotal, setSharesOwnedPercTotal] = useState<number>(0)
    const [percToRemove, setPercToRemove] = useState<number>(0)
    const [sharesToRemove, setSharesToRemove] = useState<number>(0)
    const [tokenToReceive, setTokenToReceive] = useState<number>(0)
    const [xeurToReceive, setXeurToReceive] = useState<number>(0.00)


    const [showPopUp, setShowPopUp] = useState<boolean>(false)
    const [titlePopUp, setTitlePopUp] = useState<string>("")
    const [msgPopUp, setMsgPopUp] = useState<string>("")
    const [request, setRequest] = useState<any>()

    let issuedTokensList = issuedTokens?.listed_tokens ? issuedTokens.listed_tokens : []

    useEffect(() => {
        setUuid(props.uuidLP)
    }, [props.uuidLP])

    useEffect(() => {
        if (uuid) actions.getDetailsLiquidityPool(uuid, setDetailsLPRequest)
        actions.getIssuedTokens(setIssuedTokens)
        actions.getActualBalance(setBalance)
    }, [uuid])

    function updateShares() {
        if (detailsLPRequest && detailsLPRequest[0] === 200) {
            let l: any = detailsLPRequest[1]
            setTokenAName(l.token_a_ticker)
            setTokenBName(l.token_b_ticker)
            setTokenA(l.token_a_uuid)
            setTokenB(l.token_b_uuid)
            setLpName(l.lp_name)
            setAssetName(l.asset_a_name)
            setLpAmountA(l.amount_a)
            setLpAmountB(l.amount_b)
            actions.getInvestorShares(l.uuid, true, setShares)
        }
    }
    useEffect(() => {
        updateShares()
    }, [detailsLPRequest])

    useEffect(() => {
        if (shares && shares[0] && shares[0].LPWE.qty_lp_token > 0) {
            setLpShares(shares[0].LP.lp_token_supply)
            setSharesOwned(shares[0].LPWE.qty_lp_token)
            setSharesOwnedPercTotal(100 * shares[0].LPWE.qty_lp_token / shares[0].LP.lp_token_supply)
        }

    }, [shares])

    useEffect(() => {
        let tokens = issuedTokensList.filter((t: any) => t.uuid === tokenA)
        let newMax = tokens.length > 0 ? tokens[0].total_available : 0
        setMaxIssuerTokenA(newMax)
    }, [tokenA, issuedTokensList])

    useEffect(() => {
        if (balance && balance.payment_tokens) {
            setMaxTokenB(balance.payment_tokens.available_total)
        }

        let cont_investor_balance = 0
        if (balance && balance.balance) {
            for (let r of balance.balance.security_entries) {
                for (let e of r.class_balance) {
                    if (e.token_uuid === tokenA)
                        cont_investor_balance = e.available_quantity
                }
            }
        }
        setMaxTokenA(cont_investor_balance)
    }, [balance, tokenA])

    useEffect(() => {
        if (request && request.length > 0) {
            if (request[0] === 200 || request[0] === 204) {
                setTitlePopUp("Success")
                setMsgPopUp("Your request has been processed.")

            } else {
                setTitlePopUp("Sorry!")
                setMsgPopUp("We encountered an error saving your data.")
            }
            setShowPopUp(true)
        }
    }, [request])

    function handleSubmit() {
        let requestInfo = {
            lp_uuid: uuid,
            lp_token_amount: sharesToRemove,
        }
        actions.removeLiquidityPool(requestInfo, setRequest)
    }

    function handleChangeSlider(event: Event, newValue: number | number[]) {
        let value = newValue as number
        setPercToRemove(value);
        let sharesToRemove = Math.ceil(sharesOwned * value / 100)
        if (sharesToRemove !== sharesOwned * value / 100) {
            setPercToRemove(Math.ceil(sharesToRemove / sharesOwned * 10000) / 100);
        }
        setSharesToRemove(sharesToRemove)
        let token = Math.floor(lpAmountA * sharesToRemove / lpShares)
        setTokenToReceive(token)
        let xeur = Math.floor(lpAmountB * sharesToRemove / lpShares * 100) / 100
        setXeurToReceive(xeur)
    };

    return <>
        <Popup show={showPopUp} title={titlePopUp} msg={msgPopUp} btnOk={true}
            close={() => { setShowPopUp(false); props.closeFunction() }} />
        <GenericPopup
            closeFunction={() => { updateShares(); props.closeFunction() }}
            handleSubmit={() => { updateShares(); handleSubmit() }} >
            <PopupRowData backgroundColor="succ8_lightest">
                <PopupLabelAndValue label="My Balance" />
                <PopupLabelAndValue label={tokenAName} value={quantityFormat(maxTokenA)} />
                <PopupLabelAndValue label={tokenBName} value={euroFormat(maxTokenB)} />
            </PopupRowData>
            <PopupDivider color="succ8" />
            <PopupRowData nColumns="3">
                <PopupLabelAndValue label="Asset Name:" value={assetName} />
                <PopupLabelAndValue label="Ticker:" value={tokenAName} className="col-span-2"/>
            </PopupRowData>
            <PopupDivider color="succ8" />
            <PopupRowData nColumns="3">
                <PopupLabelAndValue label="My LP Balance" />
                <PopupLabelAndValue label="SHARES:" className="col-span-2"
                    value={quantityFormat(sharesOwned) + " (" + euroFormat(sharesOwnedPercTotal) + "% of the total)"} />
            </PopupRowData>
            <PopupDivider color="succ8" />
            <PopupRowData>
                <PopupLabelAndValue label="Reserves of" value={lpName} />
                <PopupLabelAndValue label={tokenAName} value={euroQtyFormat(lpAmountA)} />
                <PopupLabelAndValue label={tokenBName} value={euroFormat(lpAmountB)} />
            </PopupRowData>
            <PopupDivider color="succ8" />
            <PopupRowData backgroundColor="succ8_lighter" nColumns="1" className="text-center text-sm">
                <div className=" mx-4">
                    How many shares will you remove from <span className="font-semibold uppercase">{lpName}</span>?
                </div>
                <div className="text-primary text-xl md:text-2xl font-semibold mt-1">
                    {quantityFormat(sharesToRemove)}
                </div>

                <div className="justify-between gap-2 align-middle items-center px-10">
                    <Slider
                        aria-label="% of Shares to remove"
                        defaultValue={percToRemove}
                        valueLabelDisplay="off"
                        step={1}
                        marks={false}
                        min={0}
                        max={100}
                        onChange={handleChangeSlider}
                        sx={{
                            height: 6,
                            color: '#0A3C60',
                            '& .MuiSlider-thumb': {
                                borderRadius: '8px',
                                backgroundImage: 'url(https://dexx-public.s3.eu-south-1.amazonaws.com/image/logoCursor.png)',
                                backgroundSize: "contain",
                                backgroundPosition: "center center",
                                backgroundRepeat: "no-repeat",
                            },
                        }}
                    />
                </div>
                <div className="text-primary text-lg md:text-xl font-semibold">
                    {Math.round(percToRemove) + "%"}
                </div>
            </PopupRowData>
            <PopupDivider color="succ8" />
            <PopupRowData nColumns="3">
                <PopupLabelAndValue label="Reserves to receive" />
                <PopupLabelAndValue label={tokenAName} value={euroQtyFormat(tokenToReceive)} />
                <PopupLabelAndValue label={tokenBName} value={euroFormat(xeurToReceive)} />
            </PopupRowData>
            <PopupDivider color="succ8" />
            <PopupRowData nColumns="1" className="font-roboto mb-4 text-sm font-normal">
                <div className="text-succ8 text-sm font-medium">
                    Review</div>
                <div>% Share to redeem:
                    <strong>{Math.round(percToRemove) + "%"}</strong>
                </div>
                <div>Share to redeem:
                    <strong>{euroQtyFormat(sharesToRemove)}</strong>
                </div>
            </PopupRowData>
        </GenericPopup>
    </>
}